import {start} from './editor-startup-logic'

start()
